var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXbox360(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.425 1.943c1.5-.449 3.668.124 5.622 1.429l.024 9.065c-.714-.142-1.464-.443-2.161-.839-.715-.407-1.424-.939-2.162-1.565L6.626 5.21C5.652 4.577 1.85 3.502 2.34 2.953a10.511 10.511 0 011.086-1.01z",
    fill: "url(#xbox_360_svg__paint0_radial_920_476)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.569 1.943c-1.5-.449-3.667.124-5.622 1.429l-.024 9.065c.715-.142 1.465-.443 2.162-.839.714-.407 1.423-.939 2.161-1.565L11.368 5.21c.975-.632 4.778-1.707 4.288-2.256-.496-.544-1.087-1.01-1.087-1.01z",
    fill: "url(#xbox_360_svg__paint1_radial_920_476)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42 16.087l5.102-5.794-1.896-5.078A16.214 16.214 0 004.311 7.6c-1.795 2.262-3.36 5.445-2.817 6.384.543.94 1.925 2.103 1.925 2.103z",
    fill: "url(#xbox_360_svg__paint2_radial_920_476)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.58 16.08L9.48 10.289l1.895-5.08a16.212 16.212 0 012.315 2.387c1.795 2.261 3.36 5.444 2.817 6.383-.543.94-1.925 2.103-1.925 2.103z",
    fill: "url(#xbox_360_svg__paint3_radial_920_476)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.967 14.646A8.994 8.994 0 010 9.024c0-2.38.915-4.542 2.421-6.148 0 0 1.571.697 4.217 2.333-5.906 6.118-4.671 9.437-4.671 9.437zM9 3.466c0-.005-.006-.005 0 0 3.597-2.604 5.835-1.299 5.835-1.299A8.914 8.914 0 008.995 0c-2.233 0-4.27.815-5.841 2.167 0 0 2.238-1.34 5.84 1.294L9 3.467zm-6.502 11.77a8.941 8.941 0 006.496 2.793 8.923 8.923 0 006.508-2.805s-.95-3.933-6.537-8.067c-5.008 3.703-6.467 8.08-6.467 8.08zm13.535-.59A8.994 8.994 0 0018 9.024c0-2.38-.921-4.542-2.421-6.148 0 0-1.571.697-4.217 2.333 5.906 6.118 4.671 9.437 4.671 9.437z",
    fill: "url(#xbox_360_svg__paint4_radial_920_476)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "xbox_360_svg__paint0_radial_920_476",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.44572 0 0 6.16235 4.797 8.583)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    stopColor: "#FDFDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FAFBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    stopColor: "#F5F8E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#EFF3D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678,
    stopColor: "#E8EEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    stopColor: "#DFE7A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#D5E080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#C9D756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#BACF20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#97C129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962,
    stopColor: "#6BB42F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58AE31"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "xbox_360_svg__paint1_radial_920_476",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-6.44572 0 0 -6.16235 13.197 8.583)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    stopColor: "#FDFDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FAFBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    stopColor: "#F5F8E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#EFF3D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678,
    stopColor: "#E8EEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    stopColor: "#DFE7A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#D5E080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#C9D756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#BACF20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#97C129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962,
    stopColor: "#6BB42F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58AE31"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "xbox_360_svg__paint2_radial_920_476",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-144.003 6.225 4.504) scale(6.06636 7.23468)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FDFDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FAFBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#F5F8E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#EFF3D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692,
    stopColor: "#E8EEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#DFE7A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#D5E080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#C9D756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#BACF20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#B4CC22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#91BF2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#74B62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971,
    stopColor: "#5FB031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58AE31"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "xbox_360_svg__paint3_radial_920_476",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(4.9079 -3.56545 4.25212 5.8531 9.385 11.799)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FDFDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FAFBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#F5F8E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#EFF3D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692,
    stopColor: "#E8EEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#DFE7A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#D5E080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#C9D756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#BACF20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#B4CC22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#91BF2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#74B62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971,
    stopColor: "#5FB031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58AE31"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "xbox_360_svg__paint4_radial_920_476",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(15.925 0 0 15.9753 8.19 6.592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#E3E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#B3B1B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#8C8C8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.606,
    stopColor: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B8B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#E1E1E1"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuNDI1NDIgMS45NDI4NEM0LjkyNTQyIDEuNDk0MDMgNy4wOTI3NSAyLjA2Njg2IDkuMDQ3NDcgMy4zNzE5OEw5LjA3MTA5IDEyLjQzNjlDOC4zNTY1MyAxMi4yOTUyIDcuNjA2NTMgMTEuOTk0IDYuOTA5NjggMTEuNTk4NEM2LjE5NTExIDExLjE5MDkgNS40ODY0NSAxMC42NTk0IDQuNzQ4MjYgMTAuMDMzNEw2LjYyNjIxIDUuMjA4NTlDNS42NTE4IDQuNTc2NyAxLjg0ODY1IDMuNTAxOSAyLjMzODgxIDIuOTUyNjlDMi44MzQ4NyAyLjQwOTM4IDMuNDI1NDIgMS45NDI4NCAzLjQyNTQyIDEuOTQyODRWMS45NDI4NFoiIGZpbGw9InVybCgjcGFpbnQwX3JhZGlhbF85MjBfNDc2KSIvPgo8cGF0aCBkPSJNMTQuNTY5IDEuOTQyODRDMTMuMDY5IDEuNDk0MDMgMTAuOTAxNyAyLjA2Njg2IDguOTQ2OTYgMy4zNzE5OEw4LjkyMzM0IDEyLjQzNjlDOS42Mzc5MSAxMi4yOTUyIDEwLjM4NzkgMTEuOTk0IDExLjA4NDggMTEuNTk4NEMxMS43OTkzIDExLjE5MDkgMTIuNTA4IDEwLjY1OTQgMTMuMjQ2MiAxMC4wMzM0TDExLjM2ODIgNS4yMDg1OUMxMi4zNDI2IDQuNTc2NyAxNi4xNDU4IDMuNTAxOSAxNS42NTU2IDIuOTUyNjlDMTUuMTU5NiAyLjQwOTM4IDE0LjU2OSAxLjk0Mjg0IDE0LjU2OSAxLjk0Mjg0WiIgZmlsbD0idXJsKCNwYWludDFfcmFkaWFsXzkyMF80NzYpIi8+CjxwYXRoIGQ9Ik0zLjQxOTM4IDE2LjA4NjZMOC41MjE3NCAxMC4yOTMzTDYuNjI2MDcgNS4yMTQ2QzUuODI4ODMgNS44NzYwMiA1LjA0MzQgNi42NzkxNyA0LjMxMTExIDcuNjAwNDNDMi41MTU4NCA5Ljg2MjI0IDAuOTUwODc3IDEzLjA0NTMgMS40OTQxOCAxMy45ODQzQzIuMDM3NDkgMTQuOTIzMyAzLjQxOTM4IDE2LjA4NjYgMy40MTkzOCAxNi4wODY2VjE2LjA4NjZaIiBmaWxsPSJ1cmwoI3BhaW50Ml9yYWRpYWxfOTIwXzQ3NikiLz4KPHBhdGggZD0iTTE0LjU4MDkgMTYuMDgwOEw5LjQ3ODUyIDEwLjI4NzVMMTEuMzc0MiA1LjIwODc0QzEyLjE3MTQgNS44NzAxNiAxMi45NTY5IDYuNjczMzEgMTMuNjg5MSA3LjU5NDU3QzE1LjQ4NDQgOS44NTYzOCAxNy4wNDk0IDEzLjAzOTQgMTYuNTA2MSAxMy45Nzg0QzE1Ljk2MjggMTQuOTE3NCAxNC41ODA5IDE2LjA4MDggMTQuNTgwOSAxNi4wODA4VjE2LjA4MDhaIiBmaWxsPSJ1cmwoI3BhaW50M19yYWRpYWxfOTIwXzQ3NikiLz4KPHBhdGggZD0iTTEuOTY2NTQgMTQuNjQ1N0MwLjczODE4OSAxMy4xMDQzIDAgMTEuMTQ5NiAwIDkuMDIzNjJDMCA2LjY0MzcgMC45MTUzNTMgNC40ODIyOCAyLjQyMTI2IDIuODc1OThDMi40MjEyNiAyLjg3NTk4IDMuOTkyMTMgMy41NzI4MyA2LjYzNzggNS4yMDg2NkMwLjczMjI4NCAxMS4zMjY4IDEuOTY2NTQgMTQuNjQ1NyAxLjk2NjU0IDE0LjY0NTdWMTQuNjQ1N1pNOSAzLjQ2NjU0QzkgMy40NjA2MyA4Ljk5NDEgMy40NjA2MyA5IDMuNDY2NTRDMTIuNTk2NSAwLjg2MjIwNSAxNC44MzQ2IDIuMTY3MzIgMTQuODM0NiAyLjE2NzMyQzEzLjI2MzggMC44MTQ5NjEgMTEuMjI2NCAwIDguOTk0MDkgMEM2Ljc2MTgxIDAgNC43MjQ0MSAwLjgxNDk2MSAzLjE1MzU0IDIuMTY3MzJDMy4xNTM1NCAyLjE2NzMyIDUuMzkxNzMgMC44MjY3NzIgOC45OTQwOSAzLjQ2MDYzTDkgMy40NjY1NFpNMi40OTgwMyAxNS4yMzYyQzQuMTMzODYgMTYuOTU0NyA2LjQzNzAxIDE4LjAyOTUgOC45OTQwOSAxOC4wMjk1QzExLjU1NzEgMTguMDI5NSAxMy44NjYxIDE2Ljk1NDcgMTUuNTAyIDE1LjIyNDRDMTUuNTAyIDE1LjIyNDQgMTQuNTUxMiAxMS4yOTEzIDguOTY0NTcgNy4xNTc0OEMzLjk1NjY5IDEwLjg2MDIgMi40OTgwMyAxNS4yMzYyIDIuNDk4MDMgMTUuMjM2MlpNMTYuMDMzNSAxNC42NDU3QzE3LjI2MTggMTMuMTA0MyAxOCAxMS4xNDk2IDE4IDkuMDIzNjJDMTggNi42NDM3IDE3LjA3ODcgNC40ODIyOCAxNS41Nzg3IDIuODc1OThDMTUuNTc4NyAyLjg3NTk4IDE0LjAwNzkgMy41NzI4MyAxMS4zNjIyIDUuMjA4NjZDMTcuMjY3NyAxMS4zMjY4IDE2LjAzMzUgMTQuNjQ1NyAxNi4wMzM1IDE0LjY0NTdWMTQuNjQ1N1oiIGZpbGw9InVybCgjcGFpbnQ0X3JhZGlhbF85MjBfNDc2KSIvPgo8ZGVmcz4KPHJhZGlhbEdyYWRpZW50IGlkPSJwYWludDBfcmFkaWFsXzkyMF80NzYiIGN4PSIwIiBjeT0iMCIgcj0iMSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIGdyYWRpZW50VHJhbnNmb3JtPSJ0cmFuc2xhdGUoNC43OTcxNCA4LjU4MjU5KSBzY2FsZSg2LjQ0NTcyIDYuMTYyMzUpIj4KPHN0b3Agb2Zmc2V0PSIwLjAxMSIgc3RvcC1jb2xvcj0id2hpdGUiLz4KPHN0b3Agb2Zmc2V0PSIwLjMyIiBzdG9wLWNvbG9yPSIjRkZGRkZFIi8+CjxzdG9wIG9mZnNldD0iMC40MzEiIHN0b3AtY29sb3I9IiNGREZERjkiLz4KPHN0b3Agb2Zmc2V0PSIwLjUxIiBzdG9wLWNvbG9yPSIjRkFGQkYxIi8+CjxzdG9wIG9mZnNldD0iMC41NzQiIHN0b3AtY29sb3I9IiNGNUY4RTUiLz4KPHN0b3Agb2Zmc2V0PSIwLjYyOSIgc3RvcC1jb2xvcj0iI0VGRjNENCIvPgo8c3RvcCBvZmZzZXQ9IjAuNjc4IiBzdG9wLWNvbG9yPSIjRThFRUJFIi8+CjxzdG9wIG9mZnNldD0iMC43MjIiIHN0b3AtY29sb3I9IiNERkU3QTIiLz4KPHN0b3Agb2Zmc2V0PSIwLjc2MiIgc3RvcC1jb2xvcj0iI0Q1RTA4MCIvPgo8c3RvcCBvZmZzZXQ9IjAuNzk4IiBzdG9wLWNvbG9yPSIjQzlENzU2Ii8+CjxzdG9wIG9mZnNldD0iMC44MzIiIHN0b3AtY29sb3I9IiNCQUNGMjAiLz4KPHN0b3Agb2Zmc2V0PSIwLjg5MSIgc3RvcC1jb2xvcj0iIzk3QzEyOSIvPgo8c3RvcCBvZmZzZXQ9IjAuOTYyIiBzdG9wLWNvbG9yPSIjNkJCNDJGIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzU4QUUzMSIvPgo8L3JhZGlhbEdyYWRpZW50Pgo8cmFkaWFsR3JhZGllbnQgaWQ9InBhaW50MV9yYWRpYWxfOTIwXzQ3NiIgY3g9IjAiIGN5PSIwIiByPSIxIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgZ3JhZGllbnRUcmFuc2Zvcm09InRyYW5zbGF0ZSgxMy4xOTcyIDguNTgyNTkpIHJvdGF0ZSgxODApIHNjYWxlKDYuNDQ1NzIgNi4xNjIzNSkiPgo8c3RvcCBvZmZzZXQ9IjAuMDExIiBzdG9wLWNvbG9yPSJ3aGl0ZSIvPgo8c3RvcCBvZmZzZXQ9IjAuMzIiIHN0b3AtY29sb3I9IiNGRkZGRkUiLz4KPHN0b3Agb2Zmc2V0PSIwLjQzMSIgc3RvcC1jb2xvcj0iI0ZERkRGOSIvPgo8c3RvcCBvZmZzZXQ9IjAuNTEiIHN0b3AtY29sb3I9IiNGQUZCRjEiLz4KPHN0b3Agb2Zmc2V0PSIwLjU3NCIgc3RvcC1jb2xvcj0iI0Y1RjhFNSIvPgo8c3RvcCBvZmZzZXQ9IjAuNjI5IiBzdG9wLWNvbG9yPSIjRUZGM0Q0Ii8+CjxzdG9wIG9mZnNldD0iMC42NzgiIHN0b3AtY29sb3I9IiNFOEVFQkUiLz4KPHN0b3Agb2Zmc2V0PSIwLjcyMiIgc3RvcC1jb2xvcj0iI0RGRTdBMiIvPgo8c3RvcCBvZmZzZXQ9IjAuNzYyIiBzdG9wLWNvbG9yPSIjRDVFMDgwIi8+CjxzdG9wIG9mZnNldD0iMC43OTgiIHN0b3AtY29sb3I9IiNDOUQ3NTYiLz4KPHN0b3Agb2Zmc2V0PSIwLjgzMiIgc3RvcC1jb2xvcj0iI0JBQ0YyMCIvPgo8c3RvcCBvZmZzZXQ9IjAuODkxIiBzdG9wLWNvbG9yPSIjOTdDMTI5Ii8+CjxzdG9wIG9mZnNldD0iMC45NjIiIHN0b3AtY29sb3I9IiM2QkI0MkYiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjNThBRTMxIi8+CjwvcmFkaWFsR3JhZGllbnQ+CjxyYWRpYWxHcmFkaWVudCBpZD0icGFpbnQyX3JhZGlhbF85MjBfNDc2IiBjeD0iMCIgY3k9IjAiIHI9IjEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiBncmFkaWVudFRyYW5zZm9ybT0idHJhbnNsYXRlKDguNjEzMzkgMTEuODA2Nikgcm90YXRlKC0xNDQuMDAzKSBzY2FsZSg2LjA2NjM2IDcuMjM0NjgpIj4KPHN0b3Agb2Zmc2V0PSIwLjAxMSIgc3RvcC1jb2xvcj0id2hpdGUiLz4KPHN0b3Agb2Zmc2V0PSIwLjMyNiIgc3RvcC1jb2xvcj0iI0ZGRkZGRSIvPgo8c3RvcCBvZmZzZXQ9IjAuNDQiIHN0b3AtY29sb3I9IiNGREZERjkiLz4KPHN0b3Agb2Zmc2V0PSIwLjUyIiBzdG9wLWNvbG9yPSIjRkFGQkYxIi8+CjxzdG9wIG9mZnNldD0iMC41ODYiIHN0b3AtY29sb3I9IiNGNUY4RTUiLz4KPHN0b3Agb2Zmc2V0PSIwLjY0MiIgc3RvcC1jb2xvcj0iI0VGRjNENCIvPgo8c3RvcCBvZmZzZXQ9IjAuNjkyIiBzdG9wLWNvbG9yPSIjRThFRUJFIi8+CjxzdG9wIG9mZnNldD0iMC43MzciIHN0b3AtY29sb3I9IiNERkU3QTIiLz4KPHN0b3Agb2Zmc2V0PSIwLjc3OCIgc3RvcC1jb2xvcj0iI0Q1RTA4MCIvPgo8c3RvcCBvZmZzZXQ9IjAuODE1IiBzdG9wLWNvbG9yPSIjQzlENzU2Ii8+CjxzdG9wIG9mZnNldD0iMC44NDgiIHN0b3AtY29sb3I9IiNCQUNGMjAiLz4KPHN0b3Agb2Zmc2V0PSIwLjg1NSIgc3RvcC1jb2xvcj0iI0I0Q0MyMiIvPgo8c3RvcCBvZmZzZXQ9IjAuODk2IiBzdG9wLWNvbG9yPSIjOTFCRjJBIi8+CjxzdG9wIG9mZnNldD0iMC45MzUiIHN0b3AtY29sb3I9IiM3NEI2MkUiLz4KPHN0b3Agb2Zmc2V0PSIwLjk3MSIgc3RvcC1jb2xvcj0iIzVGQjAzMSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM1OEFFMzEiLz4KPC9yYWRpYWxHcmFkaWVudD4KPHJhZGlhbEdyYWRpZW50IGlkPSJwYWludDNfcmFkaWFsXzkyMF80NzYiIGN4PSIwIiBjeT0iMCIgcj0iMSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIGdyYWRpZW50VHJhbnNmb3JtPSJ0cmFuc2xhdGUoOS4zODUwNiAxMS43OTg4KSByb3RhdGUoLTM1Ljk5NzQpIHNjYWxlKDYuMDY2MjkgNy4yMzQ1OSkiPgo8c3RvcCBvZmZzZXQ9IjAuMDExIiBzdG9wLWNvbG9yPSJ3aGl0ZSIvPgo8c3RvcCBvZmZzZXQ9IjAuMzI2IiBzdG9wLWNvbG9yPSIjRkZGRkZFIi8+CjxzdG9wIG9mZnNldD0iMC40NCIgc3RvcC1jb2xvcj0iI0ZERkRGOSIvPgo8c3RvcCBvZmZzZXQ9IjAuNTIiIHN0b3AtY29sb3I9IiNGQUZCRjEiLz4KPHN0b3Agb2Zmc2V0PSIwLjU4NiIgc3RvcC1jb2xvcj0iI0Y1RjhFNSIvPgo8c3RvcCBvZmZzZXQ9IjAuNjQyIiBzdG9wLWNvbG9yPSIjRUZGM0Q0Ii8+CjxzdG9wIG9mZnNldD0iMC42OTIiIHN0b3AtY29sb3I9IiNFOEVFQkUiLz4KPHN0b3Agb2Zmc2V0PSIwLjczNyIgc3RvcC1jb2xvcj0iI0RGRTdBMiIvPgo8c3RvcCBvZmZzZXQ9IjAuNzc4IiBzdG9wLWNvbG9yPSIjRDVFMDgwIi8+CjxzdG9wIG9mZnNldD0iMC44MTUiIHN0b3AtY29sb3I9IiNDOUQ3NTYiLz4KPHN0b3Agb2Zmc2V0PSIwLjg0OCIgc3RvcC1jb2xvcj0iI0JBQ0YyMCIvPgo8c3RvcCBvZmZzZXQ9IjAuODU1IiBzdG9wLWNvbG9yPSIjQjRDQzIyIi8+CjxzdG9wIG9mZnNldD0iMC44OTYiIHN0b3AtY29sb3I9IiM5MUJGMkEiLz4KPHN0b3Agb2Zmc2V0PSIwLjkzNSIgc3RvcC1jb2xvcj0iIzc0QjYyRSIvPgo8c3RvcCBvZmZzZXQ9IjAuOTcxIiBzdG9wLWNvbG9yPSIjNUZCMDMxIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzU4QUUzMSIvPgo8L3JhZGlhbEdyYWRpZW50Pgo8cmFkaWFsR3JhZGllbnQgaWQ9InBhaW50NF9yYWRpYWxfOTIwXzQ3NiIgY3g9IjAiIGN5PSIwIiByPSIxIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgZ3JhZGllbnRUcmFuc2Zvcm09InRyYW5zbGF0ZSg4LjE4OTA2IDYuNTkyNDUpIHNjYWxlKDE1LjkyNSAxNS45NzUzKSI+CjxzdG9wIG9mZnNldD0iMC4wMjgiIHN0b3AtY29sb3I9IndoaXRlIi8+CjxzdG9wIG9mZnNldD0iMC4xMDUiIHN0b3AtY29sb3I9IiNFM0UyRTMiLz4KPHN0b3Agb2Zmc2V0PSIwLjI1OSIgc3RvcC1jb2xvcj0iI0IzQjFCMiIvPgo8c3RvcCBvZmZzZXQ9IjAuMzc3IiBzdG9wLWNvbG9yPSIjOTY5Njk2Ii8+CjxzdG9wIG9mZnNldD0iMC40NDQiIHN0b3AtY29sb3I9IiM4QzhDOEQiLz4KPHN0b3Agb2Zmc2V0PSIwLjUxOCIgc3RvcC1jb2xvcj0iIzkxOTE5MSIvPgo8c3RvcCBvZmZzZXQ9IjAuNjA2IiBzdG9wLWNvbG9yPSIjOUY5RjlGIi8+CjxzdG9wIG9mZnNldD0iMC43IiBzdG9wLWNvbG9yPSIjQjhCN0I3Ii8+CjxzdG9wIG9mZnNldD0iMC43OTgiIHN0b3AtY29sb3I9IiNEQ0RDREMiLz4KPHN0b3Agb2Zmc2V0PSIwLjgwOSIgc3RvcC1jb2xvcj0iI0UxRTFFMSIvPgo8L3JhZGlhbEdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgXbox360 as ReactComponent };